import {
  Directive,
  ElementRef,
  Signal,
  computed,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { FullscreenService } from '../services/fullscreen.service';

@Directive({
  selector: '[uiFullscreenTarget]',
  standalone: true,
  exportAs: 'uiFullscreenTarget',
})
export class UiFullscreenTargetDirective {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly fullscreenService = inject(FullscreenService);

  public readonly lockLandscape = input<boolean>(false);
  public readonly preventLandscape = input<boolean>(false);
  public readonly showExitButton = input<boolean>(true);

  public readonly isFullscreen: Signal<boolean> = computed(
    () =>
      this.fullscreenService.isFullscreen() &&
      this.fullscreenService.currentElement() === this.elementRef.nativeElement,
  );

  public readonly fullscreenChange = output<boolean>();

  constructor() {
    effect(() => {
      this.fullscreenChange.emit(this.isFullscreen());
    });
  }

  public toggle(): Promise<void> {
    return this.fullscreenService.toggle(
      this.elementRef.nativeElement,
      this.lockLandscape(),
      this.showExitButton(),
      this.preventLandscape(),
    );
  }

  public enter(): Promise<void> {
    return this.fullscreenService.enter(
      this.elementRef.nativeElement,
      this.lockLandscape(),
      this.showExitButton(),
      this.preventLandscape(),
    );
  }

  public exit(): Promise<void> {
    return this.fullscreenService.exit();
  }
}
